import { TabList } from "@mui/lab";
import { Tab, styled } from "@mui/material";
import { alpha } from "@mui/material/styles";

export const RootTabStyle = styled(TabList)(({ theme,length }) => ({
    width:'98%',
    borderTopLeftRadius:theme.spacing(1),
    borderTopRightRadius:theme.spacing(1),
    '& .MuiTabs-flexContainer': {
      justifyContent: 'space-between',
    },
    '& .MuiTab-root': {
      width: `${100/length}%`, // Divide the width equally into 5 tabs
    },
    // padding:theme.spacing(1),
    // borderRadius:theme.spacing(1),
    // boxShadow: '0px 3px 15px rgba(34, 35, 58, 0.5)',
  }));
  
  export const RootTabItemStyles = styled(Tab)(({ theme }) => {
    const isDark = theme.palette.mode === "dark";
    const baseBg = isDark
      ? alpha(theme.palette.common.white, 0.05)
      : alpha(theme.palette.primary.lighter, 0.9);
    const hoverBg = isDark
      ? alpha(theme.palette.common.white, 0.1)
      : alpha(theme.palette.primary.light, 0.6);

    return {
      color: isDark ? theme.palette.text.secondary : theme.palette.primary.darker,
      background: baseBg,
      borderTopLeftRadius: theme.spacing(1),
      borderTopRightRadius: theme.spacing(1),
      fontWeight: 600,
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      fontSize: "0.9rem",
      letterSpacing: 0.5,
      marginRight: theme.spacing(0.2),
      marginLeft: theme.spacing(0.2),
      maxWidth: "none",
      border: `1px solid ${alpha(theme.palette.primary.main, isDark ? 0.4 : 0.15)}`,
      boxShadow: isDark
        ? "inset 0 0 0 1px rgba(255,255,255,0.06)"
        : "inset 0 0 0 1px rgba(59,130,246,0.05)",
      transition: theme.transitions.create(["background", "color", "box-shadow"], {
        duration: theme.transitions.duration.shorter,
      }),
      "&:hover": {
        color: theme.palette.text.primary,
        background: hoverBg,
      },
      "&.Mui-selected": {
        color: theme.palette.common.white,
        backgroundImage: theme.palette.gradients.brand,
        boxShadow: theme.customShadows?.z8 ?? "0 8px 30px rgba(15,23,42,0.35)",
        borderColor: alpha(theme.palette.primary.main, 0.65),
        transition: "background 0.3s ease, color 0.3s ease",
      },
    };
  });
  